import { render, staticRenderFns } from "./current.vue?vue&type=template&id=1febbcde&scoped=true"
import script from "./current.vue?vue&type=script&lang=js"
export * from "./current.vue?vue&type=script&lang=js"
import style0 from "./current.vue?vue&type=style&index=0&id=1febbcde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1febbcde",
  null
  
)

export default component.exports